import type { Event } from '@/types/event';

export function eventVideoStartSeconds(event: Event): number {
    if (event.type === 'SCENE') {
        return event.startTime ?? 0;
    }
    return event.frames[0]?.time ?? 0;
}
